import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Button,
    message,
    Spin,
    Modal,
    Input,
    Form,
    Typography,
    Dropdown,
    Flex,
    Tooltip,
    Upload
} from "antd";
import { v4 as uuidv4 } from "uuid";
import "dayjs/locale/zh-cn";
import { useBrowserClient } from "@sui/runtime";

import {
    ChatActionButton,
    ChatBox,
    ChatBoxItem,
    ChatBubblePrompts,
    ChatFeedBack,
    ChatInternetActionButton,
    ChatLayout,
    ChatLoadingDots,
    ChatPortalActionButton,
    ChatPromptsCard,
    ChatScrollWrapper,
    ChatSiteActionButton,
    ChatWelcome,
    useWebSocketClient,
    categories,
    ChatContext,
    ChatPortalLayout
} from "@sui/chat-ui";
import {
    API,
    getcategaryList,
    getDeleteChat,
    getEvaluateData,
    getInitData,
    getNewChat,
    getSessionHistory,
    getSessionList,
    getUpdateChat,
    getZntHistory,
} from "@/api/index";
import { useMsgStore } from "@/hooks/useStore";
import useBaseRequest from "@/hooks/useBaseRequest";
import Search from "../../components/search";
import { IChatMenuItem } from "@sui/chat-ui/lib/ChatUI/components/ChatMenu";
import { getChatUrl, getUrlParam } from "@/utils/public";
import { useNavigate } from "react-router-dom";
import { BgCmdMessage } from "@/utils/message";
import {
    CloseOutlined,
    CloudUploadOutlined,
    DownOutlined,
    LoadingOutlined,
    ReloadOutlined,
    SwapRightOutlined,
} from "@ant-design/icons";
import { useArraySlicer } from "@/hooks";
import HeaderRightRender from "../HeaderRightRender";
import { parseContent, parseExtra, parseSource, parseSrcs } from "./utils";
import HelpDescription from "../helpDescription";
import RecordRTC from "recordrtc";
import Fj from "../../assets/images/fj.svg";
import SuccessPic from "../../assets/images/success.svg";
import HandlingPic from "../../assets/images/handling.svg";
import DclPic from "../../assets/images/dcl.svg";
import ErrorPic from "../../assets/images/error.svg";
import {
    Attachments
} from "@ant-design/x"
import axios from "axios";

import './ChatUI.less'

categories.map((item) => {
    if (item.key === "brain") {
        item.text = window.zntTitle ? window.zntTitle : "智能体"
        // item.text = <Tooltip title={window.zntTitle ? window.zntTitle : "智能体"} >{window.zntTitle ? window.zntTitle : "智能体"}</Tooltip>
        item.title = ""
    }

    if (item.key === "chat") {
        item.text = window.chatTitle ? window.chatTitle : "对话"
        item.title = ""
    }
    // if (item.key === "search") {
    //     item.title = ""
    // }
})

// //将ws响应json解析成对象
const parseResponse = (response) => {
    if (response) {
        return JSON.parse(response)?.data?.[0];
    }
    return null;
};
const isMd = (msg) => {
    if (!msg?.form && msg?.answer && msg?.answer !== "" && msg?.isAI) {
        return true;
    }
    return false;
};

const isIframe = (msg) => {
    if (msg && msg?.form && msg?.form?.type === "link") {
        return true;
    }
    return false;
};

export default function ChatUI(props) {
    const { embed, single, embedOptions, portalLayout, defaultChatMode = "welecome", chatBoxProps, ...others } = props;
    const { mode: newMode } = props
    console.log(props, "合并之后的props");
    const [_mode, setMode] = useState(defaultChatMode);
    const mode = useMemo(() => {
        // 嵌入的，默认不开启welcome
        return embed && !embedOptions?.showDefaultWelcome ? "conversation" : _mode
    }, [_mode, embed, embedOptions?.showDefaultWelcome])
    const navigate = useNavigate();
    const manualStoppedMsgIds = useMsgStore(
        (state) => state.manualStoppedMsgIds
    );
    const [activeMenu, setActiveMenu] = useState("chat");
    const [historyKey, setHistoryKey] = useState(
        getUrlParam("chatId") ?? ""
    );
    const [renameData, setRenameData] = useState();
    const [renameOpen, setReNameOpen] = useState(false)
    const [agentName, setAgentName] = useState()
    const [renameForm] = Form.useForm();
    const SessionCache = useRef();
    const [items, setItems] = useState([]);
    const [znwdId, setZnwtId] = useState(getUrlParam("znwdId") ?? "");
    const [deleteKey, setDeleteKey] = useState("");
    const [selectedKey, setSelectedKey] = useState("")
    const lastItemRef = useRef(
        null
    );
    const [refreshNew, setRefreshNew] = useState(""); // 用于刷新状态
    const initDataRef = useRef()
    const { data: hisData } = useBaseRequest(getZntHistory, {
        manual: true,
        onSuccess(res) { },
    })
    const [zskData, setZskData] = useState([]);
    const [selectedValue, setSelectedValue] = useState({
        key: 'all',
        label: '全部知识库'
    });
    /**
     * 切换智能体
     * @param id
     */
    const swtichZnt = (id) => {
        id && setActiveMenu("chat");
        //navigate(`/?znwdId=${key?.key ?? ""}`, { replace: true })
        // window.history.pushState({}, "", getChatUrl(id, embed));
        // console.log(getChatUrl(id, embed), "这是啥")
        // navigate(getChatUrl(id, embed), { replace: true })
        if (single) {

            window.location.href = getChatUrl(id, embed, single ? true : false);
        } else {
            window.history.pushState({}, "", getChatUrl(id, embed));
        }
        setZnwtId(id + "");
        setItems([]);
    };
    const {
        runAsync: requestInit,
        loading: loadingInitData,
        data: initData,
    } = useBaseRequest(() => getInitData(znwdId ? { znwdId } : {}), {
        // manual: true,
        onSuccess(res) {
            console.log(res, "1111111111111111111111111111")
            setHotList(res?.data?.hotqas?.slice(0, 6));
            const arr = []
            setZskData([{
                key: "all",
                label: "全部知识库"
            }, ...res?.data?.zskList?.map((item) => {
                return {
                    key: item.id,
                    label: item.name
                }
            })])
            initDataRef.current = res
            setPortalSearch(res?.data?.portalSearch)
            setSiteSearch(res?.data?.siteSearch)
            setInternetSearch(res?.data?.internetSearch)
            setAgentName(res?.data?.name)
            //setZnwtId((res?.data?.id ?? "") + "")
            //res.data?.socketId && useSessionStore.set("userUid", res.data?.socketId)
        },
        refreshDeps: [znwdId],
    });
    //新建会话
    const {
        data: allZntList,
        loading,
        refresh,
    } = useBaseRequest(() => getcategaryList("0"), {
        // manual: true,
    });
    //获取所有的智能体
    const {
        data: getNewChatData,
        loading: getNewChatLoading,
        runAsync: runGetNewChat,
    } = useBaseRequest((params) => getNewChat(params), {
        manual: true,
        ready: initData?.data?.id ? true : false,
        //refreshDeps: [initData?.data?.id],
    });
    //更新会话
    const {
        data: getUpdateChatData,
        loading: getUpdateChatLoading,
        runAsync: runGetUpdateChat,
    } = useBaseRequest(
        (params) => getUpdateChat(params),
        {
            manual: true,
            //refreshDeps: [initData?.data?.id],
            onSuccess(res) {
                refreshGetSessionList();
                setRenameData({});
                setReNameOpen(false)
            },
        }
    );
    //删除回话
    const {
        data: getDeleteChatData,
        loading: getDeleteChatLoading,
        runAsync: runGetDeleteChat,
    } = useBaseRequest((params) => getDeleteChat(params), {
        manual: true,
        onSuccess(res) {
            if (newMode === "single") {
                if (historyKey === deleteKey) {
                    refreshGetSessionList();
                    swtichZnt("");
                    swtichChat("", "");

                } else {
                    // swtichZnt(historyKey)
                    refreshGetSessionList();
                }

            } else {
                if (selectedKey === deleteKey) {
                    refreshGetSessionList();
                    swtichZnt('');
                    swtichChat("", '');
                } else {
                    refreshGetSessionList();
                    // swtichChat(selectedKey);
                }
            }


        },
    });
    //查询会话历史
    const {
        data: getSessionListData,
        loading: getSessionListLoading,
        runAsync: runGetSessionList,
        refresh: refreshGetSessionList,
    } = useBaseRequest(() => getSessionList({ zntId: newMode === "single" ? znwdId : "", count: newMode === "single" ? 50 : 30 }), {
        //manual: true,
    });
    //是否是默认智能体
    const isDefaultAgent = useMemo(() => {
        if (
            initData?.data?.id &&
            !getUrlParam("znwdId") &&
            !getUrlParam("chatId")
        ) {
            return true;
        }
        return false;
    }, [initData?.data?.id, znwdId, refreshNew]);



    //当前使用的智能体信息
    const curZnt = useMemo(() => {
        return allZntList?.data?.filter(
            (element) => element.id == znwdId
        )?.[0];
    }, [znwdId, allZntList?.data]);
    const userUid = initData?.data?.socketId;
    // const { readyState, sendMessage, latestMessage, disconnect, connect } = useWebSocket(
    //   userUid ? `${API.serSocket}/${userUid}` : "",
    //   {
    //     onClose(event, instance) {
    //       console.log("onClose", event, instance)
    //     },
    //     onError(event, instance) {},
    //     onOpen(event, instance) {
    //       console.log("onOpen", event, instance)
    //     },
    //   }
    // )

    const { isMobile } = useBrowserClient(768)
    const [sending, setSending] = useState(false)
    const [receiving, setReceiving] = useState(false)
    const chatId = useRef(getUrlParam("chatId") ?? "")
    const [_chatCache, set_chatCache] = useState()
    const chatBoxRef = useRef(null)
    const sendingRef = useRef()
    const [hotList, setHotList] = useState([])
    const receivingRef = useRef()
    const [deepthink, setDeepthink] = useState(true)
    const [portalSearch, setPortalSearch] = useState(false)
    const [siteSearch, setSiteSearch] = useState(false)
    const [internetSearch, setInternetSearch] = useState(false)
    const [helpOpen, setHelpOpen] = useState(true)
    const [helpData, setHelpData] = useState([])
    const [timenum, setTime] = useState(15000)
    const lastHistoryMessage = useMemo(() => {
        return items?.length ? items?.[items?.length - 1] : null;
    }, [items]);

    console.log("最后一条数据", lastHistoryMessage);
    /**
     * 切换对话
     * @param id
     */
    const swtichChat = (id, dId) => {
        chatHistoryDate.current = "";
        id && setActiveMenu("chat");
        //navigate(`/?znwdId=${key?.key ?? ""}`, { replace: true })
        setItems([])
        console.log(items, "切换之后")
        if (newMode === "single") {
            let dhisId = getUrlParam("znwdId");
            let url = `./${location.hash}`;
            if (id) {
                url = `./?chatId=${id ?? ""}${embed ? '&embed=1' : ''}${location.hash}`;
                if (dhisId) {
                    url = `./?chatId=${id ?? ""}&znwdId=${dhisId}${embed ? '&embed=1' : ''}${location.hash}`
                }
                setHistoryKey("-1");
            } else {
                if (dhisId) {
                    url = `./?znwdId=${dhisId}${embed ? '&embed=1' : ''}${location.hash}`
                }
            }
            window.history.pushState({}, "", url);
            chatId.current = id + "";
            setItems([]);
            setHistoryKey("-1");
            if (id) {
                requestHistoryData(id);
            }
        } else {
            let url = "./"
            if (id) {
                url = `./?chatId=${id ?? ""}${embed ? '&embed=1' : ''}`
                if (dId) {
                    url = `./?chatId=${id ?? ""}&znwdId=${dId}${embed ? '&embed=1' : ''}`
                }
            } else {
                if (dId) {
                    url = `./?znwdId=${dId}${embed ? '&embed=1' : ''}`
                }
            }
            window.history.pushState({}, "", url);
            chatId.current = id + "";
            setItems([]);
            setSelectedValue({
                key: 'all',
                label: '全部知识库'
            });
            setFileList([])
            setFileOpen(false)
            if (id) {
                requestHistoryData(id);
            }
        }

        // window.history.pushState({}, "", id ? `./?chatId=${id ?? ""}&znwdId=${znwdId}` : "./");


    };
    const StartChat = async (msg, params) => {
        if (!chatId.current) {
            const chatIdRes = await runGetNewChat({
                zntId: initData?.data?.id,
                title: msg ? encodeURIComponent(msg) : "",
                // title: msg,
            });
            if (chatIdRes?.data?.chatId) {
                chatId.current = chatIdRes?.data?.chatId;
                set_chatCache(chatIdRes?.data?.chatId);
                setTimeout(() => {
                    startChat(msg, params);
                }, 0);
            }
        } else {
            startChat(msg, params);
        }
    };
    const startChat = (msg, params) => {
        if (!msg) {
            return message.info("请输入您的问题");
        }
        if (receiving || sending || sendingRef.current || receivingRef.current) {
            // return message.warning('正在处理...')
            return;
        }
        sendingRef.current = true;

        chatBoxRef.current?.senderBox?.clear();
        // sendHandler(msg)
        setMode("conversation");
        setSending(true);
        const qId = uuidv4().replaceAll("-", "");

        //preCall表单
        const preCallData =
            lastHistoryMessage?.data?.form?.type === "preCall" && params
                ? {
                    question: lastHistoryMessage?.data?.form?.question,
                    query: lastHistoryMessage?.data?.form?.query,
                    params: { ...(params ?? {}) },
                }
                : undefined;
        //useSessionStore.set(`q_${qId}`, _id)
        wsRef.current?.send(
            JSON.stringify({
                msgType: "query",
                msgData: {
                    query: msg,
                    model: "jyb_ow",
                    form: preCallData,
                    llmFlag: deepthink ? "1" : "0",
                    // llmFlag: clickActive ? "1" : "0",
                    deep_thinking: deepthink ? "1" : "0",
                    internetSearch,
                    portalSearch,
                    siteSearch,
                    s_Path: "",
                    command: "",
                    qId,
                    kb_ids: selectedValue?.key === "all" ? null : [selectedValue.key],
                    files: fileList
                },
            }),
            {
                url: `${API.serSocket}/${userUid}?chatId=${chatId.current}`,
            }
            //{ url: `${API.serSocket}/${userUid}?chatId=${chatId.current}` }
        );
        setItems((v) => {
            const item = {
                key: v.length + 1,
                loading: true,
                role: "ai",
                qId,
                content: "",
                data: {},
                typing: true,
                messageRender: (content, { Markdown, item }) => {
                    console.log(content, item)
                    const taskList = item?.data?.tasklist || [];
                    if (item?.data?.progress && !taskList.length) {
                        return (
                            <Flex align={'center'} gap={8}>
                                <span key='loading'>{item?.data?.progress?.title}</span>
                                <ChatLoadingDots />
                            </Flex>
                        );
                    }
                    if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
                        return <div key={'progress'}>
                            {(taskList?.length ? taskList : []).map((jtem, inde) => {
                                console.log(jtem)
                                return (<div key={inde}>
                                    <div style={{
                                        fontSize: "12px",
                                        padding: "5px 0"
                                    }} ><span key={jtem.status}>{handleStatus(jtem.status || '')}</span><span style={{
                                        verticalAlign: "middle",
                                        color: "#bbb",
                                        paddingLeft: "4px"
                                    }} key={jtem.name}>{jtem.name || ''}</span></div>
                                    <Markdown>{jtem.result ? jtem.result : ''}</Markdown>
                                </div>)
                            })}
                        </div>
                    }
                }
            };
            lastItemRef.current = item;
            return [
                ...v,
                {
                    key: v.length,
                    content: msg,
                    role: "user",
                    footer: (fileList && fileList.length) ? <div className="allowFile">
                        <Attachments
                            className="uploadDisable"
                            items={fileList}
                            overflow="scrollX"
                            disabled={true}
                        />

                    </div> : ""
                },
                item
            ];
        });
        setFileList([])
        setFileOpen(false)
        setSending(false);
        sendingRef.current = false;
        receivingRef.current = true;
        setReceiving(true);
    };
    const slotInput =
        lastHistoryMessage?.data?.form?.type === "preCall" &&
            lastHistoryMessage?.data?.form?.params?.length &&
            !lastHistoryMessage.typing &&
            !lastHistoryMessage.loading
            ? {
                slots: lastHistoryMessage?.data?.form?.params?.map((param) => ({
                    name: param?.field,
                    label: param?.fieldName,
                    required: param?.required,
                    defaultValue: param?.value,
                    placeholder: param?.example,
                    query: param?.query
                })),
            }
            : undefined;


    console.log(slotInput, "这是嵌入")
    const handleStatus = (status) => {
        // status = 1
        //0 待处理 1 处理中 2 成功 3 失败
        if (status === 0) {
            return <img key="DclPic" src={DclPic} alt=" " />
        } else if (status === 1) {
            return <img key="HandlingPic" src={HandlingPic} alt=" " />
        } else if (status === 2) {
            return <img key="SuccessPic" src={SuccessPic} alt=" " />
        } else if (status === 3) {
            return <img key="ErrorPic" src={ErrorPic} alt=" " />
        } else {
            return " "
        }
    }




    const handler = (_data) => {
        console.log("_data.taskList", _data, new Date())
        if (newMode === "single") {
            setSending(false);
        }
        sendingRef.current = false;
        if (_data) {
            const qId = _data.qId;
            if (lastItemRef.current && lastItemRef.current.qId) {
                lastItemRef.current.loading = false;
                lastItemRef.current.data = _data;
                lastItemRef.current.typing = !_data.isFinished;
                lastItemRef.current.process = _data.progress

                lastItemRef.current.srcs = parseSrcs(_data)
                lastItemRef.current.content = parseContent(_data);

                if (_data.isFinished) {
                    lastItemRef.current.prompts = _data?.guess;
                    lastItemRef.current.extra = parseExtra(_data)
                    lastItemRef.current.source = parseSource(_data);

                }
                setItems((v) => {
                    return [...v];
                });
            }







            if (_data.isFinished) {
                lastItemRef.current = null;
                receivingRef.current = false;
                if (initDataRef.current?.data?.talkSpeed && initDataRef.current?.data?.talkSpeed > 0) {
                    window.sessionStorage.setItem("time", JSON.stringify(new Date()))
                    setReceiving({
                        delay: initDataRef.current?.data?.talkSpeed * 1000,
                        onEnd() {
                            setReceiving(false)
                        },
                    });
                } else {
                    setReceiving(false)
                }
                //刷新左侧对话历史
                refreshGetSessionList()

            }


        }
    };

    const handleTime = () => {
        const time = window.sessionStorage.getItem("time")
        console.log(time, "暂存的时间");

        if (time) {
            const targetDate = new Date(JSON.parse(time));
            const currentDate = new Date();
            const diffMilliseconds = currentDate.getTime() - targetDate.getTime();
            // 转换为整数秒
            const diffSeconds = Math.floor(diffMilliseconds / 1000);
            console.log(diffSeconds, '差了多少秒')
            let time1 = initData?.data?.talkSpeed * 1000;
            if (initData?.data?.talkSpeed && initData?.data?.talkSpeed > 0) {
                if (diffSeconds > 0 && diffSeconds < initData?.data?.talkSpeed) {
                    time1 = (initData?.data?.talkSpeed - diffSeconds) * 1000
                }
                if (diffSeconds >= initData?.data?.talkSpeed || diffSeconds <= 0) {
                    setReceiving(false)
                } else {
                    setReceiving({
                        delay: time1,
                        onEnd: function () {
                            console.log(1111111, "end")
                            setReceiving(false)
                        },
                    });
                }
            } else {
                setReceiving(false)
            }



        } else {

            setReceiving(false)
        }
    }

    useEffect(() => {
        handleTime()

    }, [initData?.data?.talkSpeed])

    useEffect(() => {
        const id = getUrlParam("znwdId");
        console.log(id, "存储的选中的历史对话的智能体id")
        if (id) {
            setZnwtId(id)
        }
    }, [])

    const wsRef = useWebSocketClient(
        userUid && chatId.current
            ? `${API.serSocket}/${userUid}?chatId=${chatId.current}`
            : "",
        {
            onMessage(data) {
                if (data === "pong" || data === "ping") {
                    return;
                }
                console.log(data);
                try {
                    handler(parseResponse(data));
                } catch (error) { }
            },
            onClose() {
                receivingRef.current = false;
                setReceiving(false);
            },
        }
    );


    // useEffect(() => {
    //   if (latestMessage?.data === "ping" || latestMessage?.data === "pong") {
    //     return
    //   }

    //   if (latestMessage?.data) {
    //     handler(parseResponse(latestMessage))
    //   }
    // }, [latestMessage])
    const { run: requestEvaluate, runAsync: requestEvaluateAsync } =
        useBaseRequest(getEvaluateData, {
            manual: true,
            onSuccess(res) {
                message.success("感谢您的支持");
            },
        });
    const chatHistoryDate = useRef("");
    //const [chatHistroy1, setchatHistroy1] = useState<any>()
    // useEffect(() => {
    //   hisMockResponse({ count: 10, date: chatHistoryDate.current, id: znwdId }).then((res) => {
    //     setchatHistroy1(res)
    //   })
    // }, [])
    // const {
    //   runAsync: requestHistoryData,
    //   data: chatHistroy,
    //   loading: chatHistoryLoading,
    // } = useBaseRequest(
    //   (date: string = "", id?: string) => getChatList({ id: id ?? znwdId, count: 10, date }),
    //   {
    //     ready: znwdId ? true : false,
    //     //refreshDeps: [znwdId],
    //     onSuccess: (res: any) => {
    //       if (res?.data?.length) {
    //         chatHistoryDate.current = res?.data?.[res?.data?.length - 1]?.time ?? ""
    //       }
    //     },
    //   }
    // )
    const {
        runAsync: requestHistoryData,
        data: chatHistroy,
        loading: chatHistoryLoading,
    } = useBaseRequest((id) => getSessionHistory(id), {
        //ready: znwdId ? true : false,
        manual: true,
        //refreshDeps: [znwdId],
        onSuccess: (res) => {
            console.log(res, "历史数据")
            if (res?.data?.length) {
                // chatHistoryDate.current = res?.data?.[res?.data?.length - 1]?.time ?? ""
                const _items = [];
                [...(res?.data ?? [])]?.reverse?.()?.forEach((item) => {
                    console.log(item, "11223131313123历史对话")
                    _items.push({
                        role: "user",
                        content: item?.qa?.query ?? "",
                        //key: uuidv4().replaceAll("-", ""),
                        footer: (item?.qa?.files && item?.qa?.files.length) ? <div className="allowFile">
                            <Attachments
                                className="uploadDisable"
                                items={item?.qa?.files}
                                overflow="scrollX"
                                disabled={true}
                            />

                        </div> : ""
                    });
                    _items.push({
                        role: "ai",
                        qId: item?.qa?.qId,
                        loading: false,
                        typing: false,
                        //key: uuidv4().replaceAll("-", ""),
                        data: item?.qa,
                        content: parseContent(item?.qa),
                        messageRender: (content, { Markdown, item }) => {
                            console.log(content, item)
                            const taskList = item?.data?.tasklist || [];
                            if (item?.data?.progress && !taskList.length) {
                                return (
                                    <Flex align={'center'} gap={8}>
                                        <span key='loading'>{item?.data?.progress?.title}</span>
                                        <ChatLoadingDots />
                                    </Flex>
                                );
                            }
                            if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
                                return <div key={'progress'}>
                                    {(taskList?.length ? taskList : []).map((jtem, inde) => {
                                        console.log(jtem)
                                        return (<div key={inde}>
                                            <div style={{
                                                fontSize: "12px",
                                                padding: "5px 0"
                                            }} ><span key={jtem.status}>{handleStatus(jtem.status || '')}</span><span style={{
                                                verticalAlign: "middle",
                                                color: "#bbb",
                                                paddingLeft: "4px"
                                            }} key={jtem.name}>{jtem.name || ''}</span></div>
                                            <Markdown>{jtem.result ? jtem.result : ''}</Markdown>
                                        </div>)
                                    })}
                                </div>
                            }
                        },
                        srcs: parseSrcs(item?.qa),
                        prompts: item?.guess || item?.qa?.guess,
                        source: parseSource(item?.qa),
                        extra: parseExtra(item?.qa),
                        defaultOpenSrcs: false // 默认不打开历史消息的外链页面
                    });
                });
                setItems((v) => [..._items, ...v]);
            }
        },
    });
    useEffect(() => {
        if (chatId?.current) {
            requestHistoryData(chatId.current);
        }
    }, []);

    const onSendHistory = (key, item) => {
        console.log(key, item, "我在切换对话")
        handleTime();
        setHelpOpen(true);

        swtichChat(key, "");
        setHistoryKey(key);
        setFileList([]);
        setFileOpen(false);
    };
    const handleEvaluate = (
        rate,
        str,
        chatInstance = {}
    ) => {
        const { qId: msgId, data } = chatInstance;
        console.log(data, "点赞数据");
        const {
            query,
            answer,
            content,
            html,
            s_Path,
            s_Date,
            knowledge_id,
            knowledge_type,
            graph,
            relaItems = [],
            // reference: { referenceList = [] },
            reference = [],
            urlList = [],
            attachmentList = [],
        } = data;

        const obj = {
            qId: msgId,
            question: query,
            answer: answer || content || html || "AI",
            score: rate === "good" ? 5 : 1,
            date: s_Date,
            knowledge_id,
            knowledge_type,
        };

        if (str) {
            obj.suggestion = str;
        }
        if (s_Path) {
            obj.graph = 1;
            obj.question = s_Path + "/" + query;
            obj.answer = graph?.answer;
        }
        if (relaItems.length) {
            obj.refItems = JSON.stringify(relaItems);
        }
        // if (referenceList && referenceList.length) {
        //   obj.references = JSON.stringify(referenceList);
        // }
        if (reference && reference.length) {
            obj.references = JSON.stringify(reference);
        }
        if (urlList.length) {
            obj.links = JSON.stringify(urlList);
        }
        if (attachmentList.length) {
            obj.attachments = JSON.stringify(attachmentList);
        }
        requestEvaluateAsync(obj).then((res) => {
            if (res) {
                message.success(rate === "good" ? "感谢您的支持" : "感谢您的反馈");
            }
        });
    };
    const [feedback, setFeedback] = useState(null);
    const promptsItems = hotList?.length
        ? hotList.map((subject) => {
            return {
                key: subject.id,
                description: subject.name,
            };
        })
        : undefined;
    useEffect(() => {
        // const _items: Array<ChatMessageDataType & { qId?: string }> = [];
        // //有历史记录
        // if (chatHistroy?.data?.length) {
        //     [...(chatHistroy?.data ?? [])]?.reverse?.()?.forEach((item: any) => {
        //         console.log(item, "11223131313123历史对话")
        //         _items.push({
        //             role: "user",
        //             content: item?.qa?.query ?? "",
        //             //key: uuidv4().replaceAll("-", ""),
        //             footer: (item?.qa?.files && item?.qa?.files.length) ? <div className="allowFile">
        //                 <Attachments
        //                     className="uploadDisable"
        //                     items={item?.qa?.files}
        //                     overflow="scrollX"
        //                     disabled={true}
        //                 />

        //             </div> : ""
        //         });
        //         _items.push({
        //             role: "ai",
        //             qId: item?.qa?.qId,
        //             loading: false,
        //             typing: false,
        //             //key: uuidv4().replaceAll("-", ""),
        //             data: item?.qa,
        //             content: parseContent(item?.qa),
        //             messageRender: (content, { Markdown, item }) => {
        //                 console.log(content, item)
        //                 const taskList = item?.data?.tasklist || [];
        //                 if (item?.data?.progress && !taskList.length) {
        //                     return (
        //                         <Flex align={'center'} gap={8}>
        //                             <span key='loading'>{item?.data?.progress?.title}</span>
        //                             <ChatLoadingDots />
        //                         </Flex>
        //                     );
        //                 }
        //                 if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
        //                     return <div key={'progress'}>
        //                         {(taskList?.length ? taskList : []).map((jtem: any, inde: any) => {
        //                             console.log(jtem)
        //                             return (<div key={inde}>
        //                                 <div style={{
        //                                     fontSize: "12px",
        //                                     padding: "5px 0"
        //                                 }} ><span key={jtem.status}>{handleStatus(jtem.status || '')}</span><span style={{
        //                                     verticalAlign: "middle",
        //                                     color: "#bbb",
        //                                     paddingLeft: "4px"
        //                                 }} key={jtem.name}>{jtem.name || ''}</span></div>
        //                                 <Markdown>{jtem.result ? jtem.result : ''}</Markdown>
        //                             </div>)
        //                         })}
        //                     </div>
        //                 }
        //             },
        //             srcs: parseSrcs(item?.qa),
        //             prompts: item?.guess || item?.qa?.guess,
        //             source: parseSource(item?.qa),
        //             extra: parseExtra(item?.qa),
        //             defaultOpenSrcs: false // 默认不打开历史消息的外链页面
        //         });
        //     });
        // }
        // setItems((v) => [..._items, ...v]);


    }, [chatHistroy?.data, initData?.data?.znttype]);
    useEffect(() => {
        setMode(items?.length ? "conversation" : "welcome");
        //智能体直接进入对话模式
        if (!isDefaultAgent && !single) {
            // _items.push({
            //   role: "ai",
            //   content: "placeholder",
            //   loading: false,
            //   typing: false,
            //   qId: "placeholder-context",
            //   key: _items?.length,
            // })
            setMode("conversation");
        }
    }, [items, isDefaultAgent, single]);
    useEffect(() => {
        if (!loadingInitData) {
            document.title = initData ? (initData?.data?.sysname || "") : "";
        } else {
            document.title = window.location.host
        }

    }, [initData?.data?.sysname, znwdId]);

    useEffect(() => {
        if (renameOpen) {
            renameForm?.setFieldValue("name", renameData?.name)
        }
    }, [renameOpen])

    //检验用户是否登录
    useEffect(() => {
        if (!initData?.data?.userId && initData?.data?.forcelogin === 1) {
            if (process.env.NODE_ENV === "development") {
                return;
            }
            const baseUrl = window.location.protocol + "//" + window.location.host;
            const hash = window.location.hash;
            console.log(hash, "检验用户是否登录的hash");
            const url = new URL(initData?.data?.loginUrl, baseUrl)
            if (window.location.href.includes("#/single")) {
                url.searchParams.set("znwdId", initData?.data?.id)
                // window.location.href = initData?.data?.loginUrl + `?znwdId=${initData?.data?.id}`;
                if (hash) {
                    window.sessionStorage.setItem("hash", hash)
                }

                window.location.href = url.toString()
            } else {
                window.location.href = initData?.data?.loginUrl
            }

        } else {
            const newhash = window.sessionStorage.getItem("hash")
            if (newhash) {

                if (window.location.href.includes("#/single")) {
                    window.location.href = window.location.href
                    return
                }
                window.location.href = window.location.href + newhash;
                window.sessionStorage.removeItem("hash");

            }
            console.log(window.location.hash, "检验用户是否登录的hash");
        }
    }, [initData?.data]);

    //刷新热门

    const nextHots = useArraySlicer(initData?.data?.hotqas, 6);
    const onReloadHots = () => {
        setHotList(nextHots());
    };

    console.log(2120, items, chatId.current, znwdId, activeMenu, curZnt, isDefaultAgent);
    const cancelHandler = () => {
        if (lastItemRef.current?.typing) {

            manualStoppedMsgIds.push(lastItemRef.current?.qId ?? "");
            wsRef.current?.send(
                JSON.stringify(
                    BgCmdMessage({
                        msgId: lastItemRef.current?.qId ?? "",
                        command: "shutdown",
                    })
                ),
                {
                    url: `${API.serSocket}/${userUid}?chatId=${chatId.current}`,
                }
            );
        }
        if (lastItemRef.current) {
            lastItemRef.current.loading = false
            lastItemRef.current.typing = false;
            lastItemRef.current.content = '已经取消'
        }
        lastItemRef.current = null;
        setSending(false);
        setReceiving(false)
        sendingRef.current = false
        receivingRef.current = false
        wsRef.current?.close()

    }

    //录音相关
    const [recording, setRecording] = useState(false)
    const recorderRef = useRef(null);
    const audioRef = useRef(null)

    const startRecording = async () => {
        const ws = new WebSocket(API.audioSocket)

        ws.onmessage = (data) => {
            console.log(data, "返回的录音信息")
            if (data === "pong" || data === "ping") {
                return;
            }
            try {
                const obj = (data && data.data) ? JSON.parse(data?.data) : {}
                chatBoxRef.current?.senderBox.setContent(obj?.message || "")
            } catch {

            }
        }

        // 新增错误和关闭监听
        ws.onerror = (error) => {
            console.error("WebSocket 错误:", error);
            ws.close(); // 异常时强制关闭
        };
        ws.onopen = async () => {
            console.log("链接成功")
            let stream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true });
            const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
                type: 'audio',
                mimeType: 'audio/wav',
                recorderType: RecordRTC.StereoAudioRecorder,
                timeSlice: 40,
                desiredSampRate: 16000,
                numberOfAudioChannels: 1,
                ondataavailable: async (blob) => {
                    // const arrayBuffer = await blob.arrayBuffer()
                    ws.send(blob);
                },
            })

            recorder.startRecording()
            recorderRef.current = recorder
            audioRef.current = ws
            setRecording(true)
        }





    }

    //停止录音
    const stopRecording = () => {

        if (recorderRef.current && audioRef.current) {
            const recorder = recorderRef.current;
            const ws = audioRef.current;
            recorder.stopRecording(() => {
                setTimeout(() => {
                    // 检查 WebSocket 状态再操作
                    if (ws.readyState === WebSocket.OPEN) {
                        try {
                            // 发送明确的结束指令到服务器（如 "{type: 'stop'}"）
                            ws.send("");
                            ws.close();
                            console.log("WebSocket 关闭成功");
                        } catch (error) {
                            console.error("关闭 WebSocket 失败:", error);
                        }
                    }
                    // 清理引用
                    audioRef.current = null;
                    recorderRef.current = null;
                    setRecording(false);
                }, 1000);
            });



            // recorderRef.current.stopRecording(() => {
            //     setTimeout(() => {
            //         audioRef.current?.send('');
            //         audioRef.current?.close();
            //     }, 1000)


            //     setRecording(false);
            // });
        }

    }


    //上传图片相关
    const [fileOpen, setFileOpen] = useState(false);
    const attachmentsRef = useRef(null)
    const [fileList, setFileList] = useState([])
    const picRef = useRef()
    const fileRef = useRef()
    const fileAndImgRef = useRef()

    //文件和图片上传相关
    const header = (
        fileOpen ? <div style={{
            minHeight: "120px",
            background: "#fff",
            borderRadius: "12px",
            position: 'relative'
        }} className="headerFile">
            <div style={{
                textAlign: "right",
                position: "absolute",
                right: "10px",
                top: "10px",
                zIndex: "99"
            }}><CloseOutlined style={{
                cursor: "pointer"
            }} onClick={() => {
                setFileOpen(false)
                setFileList([])
            }} /></div>
            <Attachments
                overflow="scrollX"
                ref={attachmentsRef}
                items={fileList}
                multiple={true}
                accept={(initData?.data?.enabledfileupload * 1 === 1 && initData?.data?.enabledimgupload * 1 === 1) ? ".jpg,.jpeg,.png,.csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" : (initData?.data?.enabledimgupload * 1 === 1 ? ".jpg,.jpeg,.png," : (initData?.data?.enabledfileupload * 1 === 1 ? ".csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt" : ""))}
                maxCount={(initData?.data?.enabledfileupload * 1 === 1 && initData?.data?.enabledimgupload * 1 === 1) ? ((initData?.data?.fileuploadcount * 1 + initData?.data?.imguploadcount * 1)) : (initData?.data?.enabledfileupload * 1 === 1 ? (initData?.data?.fileuploadcount * 1) : (initData?.data?.enabledimgupload * 1 === 1 ? (initData?.data?.imguploadcount * 1) : undefined))}
                beforeUpload={(file) => {
                    console.log(file, "上传前的文件类型")
                    let uploadTypes = []
                    if (initData?.data?.enabledfileupload * 1 === 1 && initData?.data?.enabledimgupload * 1 === 1) {
                        uploadTypes = [
                            'image/jpeg', 'image/png', 'image/gif', 'image/bmp',
                            'application/pdf',
                            'application/msword',       // .doc
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                            'application/vnd.ms-powerpoint', // .ppt
                            'application/vnd.ms-excel', // .xls
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                            'text/markdown',      // .md
                            'text/csv',           // .csv
                            'text/plain'          // 兼容扩展名检查
                        ];
                    } else {
                        if (initData?.data?.enabledfileupload * 1 === 1) {
                            uploadTypes = uploadTypes = [
                                'application/pdf',
                                'application/msword',       // .doc
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                'application/vnd.ms-powerpoint', // .ppt
                                'application/vnd.ms-excel', // .xls
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                                'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
                                'text/markdown',      // .md
                                'text/csv',           // .csv
                                'text/plain'          // 兼容扩展名检查
                            ];
                        }

                        if (initData?.data?.enabledimgupload * 1 === 1) {
                            uploadTypes = [
                                'image/jpeg', 'image/png', 'image/gif', 'image/bmp',
                            ];
                        }
                    }

                    const newCount = fileList.length + 1; // 当前已选 + 待上传
                    console.log(fileList, "已经上传的附件")
                    if (initData?.data?.enabledfileupload * 1 === 1 && initData?.data?.enabledimgupload * 1 === 1) {

                        const imageCount = fileList.filter((file) => file.type === "image").length;
                        const fileCount = fileList.filter((file) => file.type === "document").length
                        if (imageCount >= initData?.data?.imguploadcount * 1) {
                            message.warning(`最多只能上传${initData?.data?.imguploadcount * 1}张图片`)
                            return false
                        }

                        if (fileCount >= initData?.data?.fileuploadcount * 1) {
                            message.warning(`最多只能上传${initData?.data?.fileuploadcount * 1}个附件`)
                            return false
                        }


                        if (newCount > (initData?.data?.fileuploadcount * 1 + initData?.data?.imguploadcount * 1)) {
                            message.warning(`最多只能上传${initData?.data?.fileuploadcount * 1 + initData?.data?.imguploadcount * 1}个附件`)
                            return false
                        }
                    } else {
                        if (initData?.data?.enabledfileupload * 1 === 1) {
                            if (newCount > (initData?.data?.fileuploadcount * 1)) {
                                message.warning(`最多只能上传${initData?.data?.fileuploadcount * 1}个附件`)
                                return false
                            }
                        }

                        if (initData?.data?.enabledimgupload * 1 === 1) {
                            if (newCount > (initData?.data?.imguploadcount * 1)) {
                                message.warning(`最多只能上传${initData?.data?.imguploadcount * 1}张图片`)
                                return false
                            }
                        }

                    }


                    const isAllowed = uploadTypes.includes(file.type);

                    // 获取文件扩展名
                    const fileName = file.name;
                    const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

                    // 设置不同文件类型的大小限制
                    const isImage = ['jpg', 'jpeg', 'png'].includes(extension);
                    const maxSize = isImage ? 30 * 1024 * 1024 : 100 * 1024 * 1024; // 图片30MB，其他文件100MB

                    if (file.size > maxSize) {
                        message.error(`${isImage ? '图片' : '文件'}大小不能超过${isImage ? '30MB' : '100MB'}`);
                        return Upload.LIST_IGNORE;
                    }

                    if (!isAllowed) {
                        message.error('仅支持图片、文档、Markdown (.md) 和 CSV (.csv) 文件');
                        return Upload.LIST_IGNORE; // 阻止添加到文件列表
                    }




                    return true;
                }}
                onRemove={(file) => {
                    const newFileList = fileList.filter((item) => item.uid !== file.uid);
                    setFileList(newFileList)
                }}
                customRequest={(val) => {
                    console.log(val)
                    const {
                        file,
                    } = val
                    const formData = new FormData();
                    console.log(file, file.size, "上传的文件大小阿")
                    formData.append("files", file,);
                    axios.post(API.uploadDocs, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },

                    }).then((res) => {
                        const data = res?.data?.result?.data || []
                        const arr = [];
                        data.map((item) => {
                            arr.push({
                                uid: item.uuid,
                                name: item.filename,
                                status: 'done',
                                url: API.askDownLoadDocs + `?uuid=${item.uuid}`,
                                type: item.type,
                                uuid: item.uuid,
                                size: file.size
                            })
                        })
                        console.log(fileList, '已经上传的附件')
                        setFileList([...fileList, ...arr])
                    })


                }}
                placeholder={(type) =>
                    type === 'drop'
                        ? {
                            title: 'Drop file here',
                        }
                        : {
                            icon: <CloudUploadOutlined />,
                            title: '上传文件',
                            description: '单击或拖动文件到此区域进行上传',
                        }
                }
            ></Attachments>
        </div> : undefined
    )




    useEffect(() => {
        if (fileOpen && attachmentsRef.current) {
            console.log('Attachments component mounted:', attachmentsRef.current);
        }
    }, [fileOpen]);
    return (
        <ChatContext.Provider value={{ chat: StartChat, changeAgent: swtichZnt, data: initData?.data, promptsItems, reloadHots: onReloadHots }}>
            <ChatPortalLayout {...(typeof portalLayout === 'object' ? portalLayout : {})} hide={!portalLayout} title={agentName}>
                <Spin
                    indicator={<LoadingOutlined spin />}
                    spinning={loadingInitData && !initData?.data}
                >
                    <ChatLayout
                        title={newMode === "single" ? initData?.data?.name : initData?.data?.sysname}
                        user={initData?.data?.userId ? { // 未登录，不显示登录信息
                            name:
                                initData?.data?.userName ?? initData?.data?.userId ?? "未登录",
                            id: initData?.data?.userId,
                        } : undefined}
                        style={{
                            visibility:
                                loadingInitData && !initData?.data ? "hidden" : "visible",
                        }}
                        onClickCategory={(e, menu) => {
                            if (menu.key === "chat") {
                                swtichChat("", '');
                                swtichZnt("");
                            }
                        }}
                        headerRight={
                            mode == "conversation" && items.length ? (
                                <HeaderRightRender
                                    onNew={() => {
                                        cancelHandler();
                                        swtichChat("", znwdId);
                                        setRefreshNew(znwdId);
                                        handleTime();
                                    }}
                                    onHelp={(open) => {
                                        setHelpOpen(typeof open === "boolean" ? open : v => !v)
                                    }}
                                    helpOpen={helpOpen}
                                    helpPage={initData?.data?.helpPage}
                                ></HeaderRightRender>
                            ) : null
                        }
                        //帮助栏
                        containerSider={<HelpDescription helpOpen={helpOpen} helpPage={initData?.data?.helpPage} onSearch={(a) => {
                            console.log(a, "搜索")
                            chatBoxRef.current?.senderBox?.insertContent(a)
                        }} sysname={initData?.data?.name} zntId={initData?.data?.id} syslogo={initData?.data?.icon} syssummary={initData?.data?.summary} helpData={helpData} />}
                        containerSiderProps={{
                            collapsed: helpOpen,
                            toggleRender: false,
                            width: 285
                        }}
                        categories={categories}
                        headerTitle={
                            mode == "conversation" && items.length
                                ? initData?.data?.name
                                : undefined
                        }
                        hideCategories={!initData?.data?.searchUI ? ["search"] : []}
                        footer={initData?.data?.friendlytips}
                        logo={newMode === "single" ? initData?.data?.icon : initData?.data?.syslogo}
                        //aside={<HelpRender></HelpRender>}
                        onCategoryChange={(categoryKey, menu) => {
                            handleTime();
                            setHelpOpen(true);
                            setActiveMenu(categoryKey);
                            if (categoryKey !== "chat") {
                                swtichChat("", '');
                            }
                        }}

                        // headerRight={
                        //   mode == "conversation" && items.length ? (
                        //     <Popover content={"清除上下文"}>
                        //       <Button type='text' icon={<ClearOutlined></ClearOutlined>}></Button>
                        //     </Popover>
                        //   ) : undefined
                        // }
                        className={mode === "conversation" ? "aling-chat-layout" : "chatStyle"}
                        loadingCoversations={loadingInitData}
                        onClickRecentExtraButton={(e) => {
                            e.preventDefault();
                            setActiveMenu("brain");
                            swtichChat("", '');
                            return false;
                        }}
                        category={activeMenu}
                        conversationKey={
                            activeMenu === "chat" && chatId?.current
                                ? chatId?.current + ""
                                : "-1"
                        }
                        getSiderToggleStyle={(c) => (c ? {} : { right: 10 })}
                        header={mode == "conversation" && items.length ? true : false}
                        headless={embed ? Object.assign({ aitRobot: true }, embedOptions?.headless) : undefined}
                        {...others}
                        isMobile={isMobile}
                        // headerRight={
                        //   mode == "conversation" && items.length ? (
                        //     <HeaderRightRender
                        //       onClear={() => {
                        //         chatId.current &&
                        //           runGetDeleteChat(chatId.current).then((res) => {
                        //             refreshGetSessionList()
                        //           })
                        //         //setItems([])
                        //         swtichZnt(SessionCache.current?.zntId)
                        //         chatId.current = ""
                        //       }}
                        //     ></HeaderRightRender>
                        //   ) : null
                        // }
                        mode={newMode}
                        onConversationChange={(
                            conversationKey,
                            menu
                        ) => {
                            console.log(menu, conversationKey, "历史对话");
                            cancelHandler();
                            handleTime();
                            swtichChat(conversationKey, (menu)?.zntId ?? "");
                            setZnwtId((menu)?.zntId ?? "");
                            setSelectedKey(conversationKey);
                            setHelpOpen(true)
                            SessionCache.current = menu;
                        }}
                        historyKey={historyKey}
                        onHistoryChange={onSendHistory}
                        histories={getSessionListData?.data?.map((item) => ({
                            key: item?.id,
                            name: item?.title,
                            timestamp: item?.updateTime,
                        }))}
                        coversations={newMode === "single" ? hisData?.data?.map((his) => {
                            return {
                                key: his.id + "",
                                name: his.name,
                                recentMessage: his.query,
                            };
                        }) : getSessionListData?.data

                            ?.map((his) => {
                                return {
                                    key: his.id + "",
                                    name: his.title,
                                    icon: his.icon,
                                    //recentMessage: his.title,
                                    zntId: his.zntId,
                                };
                            })}
                        defaultCollapsed={isMobile}
                        historiesMenuProps={{
                            actions: ["delete", "rename"],
                            onClickAction(action, menu, index) {
                                if (action === "rename") {
                                    setRenameData(menu);
                                    setReNameOpen(true)
                                    return;
                                }
                                Modal.confirm({
                                    title: "是否确定删除此条对话？",
                                    content: "",
                                    onOk: () => {
                                        setDeleteKey(menu?.key || '')
                                        runGetDeleteChat(menu?.key || "");
                                    },
                                });
                            },
                        }}
                        coversationsMenuProps={{
                            actions: ["delete", "rename"],
                            hideActionsInMainMenu: true,
                            onClickAction(action, menu, index) {
                                if (action === "rename") {
                                    setRenameData({ ...menu });
                                    setReNameOpen(true)

                                    console.log(menu, "重命名的每条数据");
                                    return;
                                }
                                Modal.confirm({
                                    title: "是否确定删除此条对话？",
                                    content: "",
                                    onOk: () => {
                                        setDeleteKey(menu?.key || '')
                                        runGetDeleteChat(menu?.key || "");
                                    },
                                });
                            },
                        }}
                        {...((embed && embedOptions?.layout) ? embedOptions?.layout : {})}

                    >
                        {activeMenu === "chat" ? (
                            loadingInitData || (chatHistoryLoading && items.length === 0) ? (
                                <Spin
                                    size="large"
                                    wrapperClassName="chat-loading"
                                    indicator={<LoadingOutlined spin />}
                                    spinning
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                        }}
                                    ></div>
                                </Spin>
                            ) : (
                                <>
                                    <ChatBox

                                        key={"key" + znwdId}
                                        slotsInput={slotInput}
                                        sending={sending || sendingRef.current}
                                        allowSpeech={initData?.data?.enabledvinput ? {
                                            recording: recording,
                                            onRecordingChange: (val) => {
                                                if (val) {
                                                    startRecording()
                                                    setRecording(val)
                                                } else {
                                                    stopRecording()
                                                    setRecording(val)
                                                }

                                            }
                                        } : undefined}
                                        header={header}
                                        //复制文件
                                        onPasteFile={async (event, files) => {
                                            if ((initData?.data?.enabledimgupload * 1 === 1 || initData?.data?.enabledfileupload * 1 === 1)) {
                                                setFileOpen(true);
                                                console.log('Files received:', files);
                                                console.log('attachmentsRef.current:', attachmentsRef.current);
                                                setTimeout(() => {
                                                    if (files && files.length > 0 && attachmentsRef.current?.upload) {
                                                        for (const file of files) {
                                                            try {
                                                                attachmentsRef.current.upload(file); // 异步处理
                                                            } catch (error) {
                                                                console.error('Error uploading file:', error);
                                                            }
                                                        }
                                                    }
                                                }, 5);
                                            } else {
                                                return ""
                                            }


                                        }}
                                        //文件上传
                                        beforeSendActions={<>

                                            {
                                                (initData?.data?.enabledimgupload * 1 === 1 && initData?.data?.enabledfileupload * 1 === 1) ? <>
                                                    <Tooltip title={<div >
                                                        {`请上传图片或者文件（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式，最多上传${initData?.data?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、 XLSX、 XLS、 DOCX、 CSV、 MD格式）`}
                                                    </div>}>
                                                        <span onClick={() => {
                                                            fileAndImgRef?.current?.click()
                                                        }}>
                                                            <img style={{
                                                                width: "24px",
                                                                height: "24px",
                                                                cursor: "pointer"
                                                            }} src={Fj} alt=" " /><input type="file" style={{
                                                                display: "none"
                                                            }} ref={fileAndImgRef} onChange={(a) => {

                                                                setFileOpen(true);
                                                                setTimeout(() => {
                                                                    if (a.target.files && a.target.files.length > 0 && attachmentsRef.current?.upload) {
                                                                        for (const file of a.target.files) {
                                                                            try {
                                                                                attachmentsRef.current.upload(file); // 异步处理
                                                                            } catch (error) {
                                                                                console.error('Error uploading file:', error);
                                                                            }
                                                                        }
                                                                    }
                                                                }, 5);
                                                            }} />
                                                        </span>

                                                    </Tooltip>

                                                </> : <>
                                                    {
                                                        initData?.data?.enabledimgupload * 1 === 1 ? <Tooltip title={`${(initData?.data?.enabledimgupload * 1 === 1 && initData?.data?.enabledfileupload * 1 === 1) ? "请上传图片或者文件" : (initData?.data?.enabledimgupload * 1 === 1 ? `请上传图片（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式` : "")}`} > <span
                                                            onClick={() => {
                                                                picRef?.current?.click()
                                                            }}
                                                        ><img style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            cursor: "pointer"
                                                        }} src={Fj} alt=" " /><input type="file" style={{
                                                            display: "none"
                                                        }} ref={picRef} onChange={(a) => {

                                                            setFileOpen(true);
                                                            setTimeout(() => {
                                                                if (a.target.files && a.target.files.length > 0 && attachmentsRef.current?.upload) {
                                                                    for (const file of a.target.files) {
                                                                        try {
                                                                            attachmentsRef.current.upload(file); // 异步处理
                                                                        } catch (error) {
                                                                            console.error('Error uploading file:', error);
                                                                        }
                                                                    }
                                                                }
                                                            }, 5);
                                                        }} /></span> </Tooltip> : undefined
                                                    }

                                                    {
                                                        initData?.data?.enabledfileupload * 1 === 1 ?
                                                            <Tooltip title={<div >{`${(initData?.data?.enabledimgupload * 1 === 1 && initData?.data?.enabledfileupload * 1 === 1) ? "请上传图片或者文件" : (initData?.data?.enabledfileupload * 1 === 1 ? `请上传文件，最多上传${initData?.data?.fileuploadcount}个文件，，每个文件大小100MB以内，支持TXT、PDF、XLSX、XLS、DOCX、CSV、MD格式` : "")}`}</div>}>
                                                                <span onClick={() => {
                                                                    fileRef?.current?.click()
                                                                }}>
                                                                    <img style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        cursor: "pointer"
                                                                    }} src={Fj} alt=" " />
                                                                    <input type="file" style={{
                                                                        display: "none"
                                                                    }} ref={fileRef} onChange={(a) => {
                                                                        setFileOpen(true)
                                                                        setTimeout(() => {
                                                                            if (a.target.files && a.target.files.length > 0 && attachmentsRef.current?.upload) {
                                                                                for (const file of a.target.files) {
                                                                                    try {
                                                                                        attachmentsRef.current.upload(file); // 异步处理
                                                                                    } catch (error) {
                                                                                        console.error('Error uploading file:', error);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }, 5);
                                                                    }} />
                                                                </span></Tooltip>

                                                            : undefined
                                                    }


                                                </>
                                            }



                                        </>}
                                        actions={
                                            [
                                                //initData?.data?.zskList  这是根据后端返回的zskList，做的下拉
                                                (initData?.data?.zskList && initData?.data?.zskList.length > 0) ? <div key={"dropDown"} className="dropDown">
                                                    <Dropdown
                                                        trigger={['click']}
                                                        arrow={true}
                                                        menu={{
                                                            items: zskData,
                                                            selectable: true,
                                                            selectedKeys: [selectedValue.key],
                                                            onClick: ({ key }) => {
                                                                console.log(key);
                                                                const selected = zskData.find((item) => item.key === key);
                                                                console.log(selected, "下拉按钮")
                                                                if (selected) {
                                                                    setSelectedValue({
                                                                        key,
                                                                        label: selected?.label
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        key={"zskList"}
                                                    >
                                                        <ChatActionButton key={"zskList"} >
                                                            {selectedValue.key === "all" ? selectedValue.label : selectedValue.label.length > 4 ? selectedValue.label.substring(0, 4) + "..." : selectedValue.label}
                                                            { }<DownOutlined style={{
                                                                fontSize: 12,
                                                                color: 'rgba(0, 0, 0, 0.45)',
                                                                transition: 'transform 0.2s'
                                                            }} />
                                                        </ChatActionButton>
                                                    </Dropdown>
                                                </div> : null,
                                                // initData?.data?.thinking === false ? null : (
                                                //     <ChatThinkActionButton noTitle={false} key={'deepthink'} checkable value={deepthink} onChange={setDeepthink} />
                                                // ),
                                                initData?.data?.portalSearch ? <ChatPortalActionButton key={'portalsearch'} checkable value={portalSearch} onChange={setPortalSearch} >{isMobile ? "" : "门户搜索"}</ChatPortalActionButton> : null,
                                                initData?.data?.siteSearch ? <ChatSiteActionButton key={'sitesearch'} checkable value={siteSearch} onChange={setSiteSearch} >{isMobile ? "" : "站群搜索"}</ChatSiteActionButton> : null,
                                                initData?.data?.internetSearch ? <ChatInternetActionButton key={'internetserarch'} checkable value={internetSearch} onChange={setInternetSearch} /> : null
                                            ]
                                        }
                                        onClickItemPrompt={({ description }) => {
                                            StartChat(description?.toString() ?? "");
                                        }}
                                        onSubmit={(m, p) => {
                                            StartChat(m, p);
                                        }}
                                        // emboed模式下，输入框前缀图标
                                        prefixIcon={embed && embedOptions?.sendBoxPrefixIcon !== false ? embedOptions?.sendBoxPrefixIcon || true : undefined}
                                        chatListProps={{
                                            // onScrollTop(top) {
                                            //   return handleRollLoading()
                                            // },
                                            emptyHolder: isDefaultAgent ? (embed && !embedOptions?.showDefaultWelcome ?
                                                <ChatBoxItem>
                                                    <ChatWelcome layout='horizontal' size='small' footer={
                                                        <ChatBubblePrompts arrowType='swapright' gap={[16, 24]} {...embedOptions?.promptsProps} onItemClick={info => StartChat(info.data.title?.toString())} style={{ maxWidth: 900, margin: '0 auto' }} block type='primary' items={(embedOptions?.prompts || initData?.data?.hotqas)?.map(hot => ({ title: hot.name || hot.title || hot.text }))} />
                                                    }>{embedOptions?.welcome || null}</ChatWelcome>
                                                </ChatBoxItem> : null) : (
                                                <ChatBoxItem style={{ marginTop: 105 }}>
                                                    <ChatWelcome
                                                        icon={initData?.data?.icon}
                                                        alignCenter
                                                        // title={curZnt?.name}
                                                        title={initData?.data?.name}
                                                        //description={initData?.data?.syssummary}
                                                        layout="horizontal"
                                                        content={initData?.data?.summary}
                                                        size="small"
                                                        footer={
                                                            <ChatBubblePrompts
                                                                className="znt-welcome-prompts"
                                                                onItemClick={(info) =>
                                                                    StartChat(info.data.title?.toString())
                                                                }
                                                                style={{ maxWidth: 400, margin: "0 auto" }}
                                                                block
                                                                type="primary"
                                                                // content={curZnt?.name}
                                                                content={initData?.data?.name}
                                                                items={initData?.data?.hotqas
                                                                    // ?.slice(0, 3)
                                                                    ?.map((item) => ({
                                                                        title: item?.name,
                                                                        extra: <SwapRightOutlined />,
                                                                    }))}
                                                            ></ChatBubblePrompts>
                                                        }
                                                    ></ChatWelcome>
                                                </ChatBoxItem>
                                            ),
                                        }}
                                        onCancel={cancelHandler}
                                        onClickGood={(item, index) => {
                                            handleEvaluate("good", "", item);
                                        }}
                                        onClickBad={(item, index) => {
                                            setFeedback(item);
                                            // handleEvaluate("bad", "", item)
                                        }}
                                        onClickCopy={(item, index) => {
                                            return (item.data)?.answer;
                                        }}
                                        receiving={receiving || receivingRef.current}
                                        placeholder="请输入你要咨询的问题"
                                        mode={mode}
                                        welcome={chatBoxProps?.welcome || {
                                            alignCenter: true,
                                            icon: initData?.data?.sysbiglogo,
                                            title: initData?.data?.welcomemsg,
                                            content: initData?.data?.syssummary,
                                        }}
                                        renderAfterSenderBox={chatBoxProps?.renderAfterSenderBox || ((mode) => {
                                            return mode === "welcome" && promptsItems?.length ? (
                                                <ChatBoxItem>
                                                    <ChatPromptsCard
                                                        //@ts-ignore
                                                        extra={
                                                            newMode !== "single" ? <>
                                                                {
                                                                    initData?.data?.hotqas?.length > 6 ? (
                                                                        <Button
                                                                            onClick={onReloadHots}
                                                                            style={{ color: "inherit" }}
                                                                            type="text"
                                                                            icon={<ReloadOutlined />}
                                                                        ></Button>
                                                                    ) : null
                                                                }
                                                            </> : null

                                                        }
                                                        onItemClick={(info) =>
                                                            StartChat(info.data.description?.toString())
                                                        }
                                                        items={promptsItems?.slice(0, 6)}
                                                    />
                                                </ChatBoxItem>
                                            ) : null;
                                        })}
                                        items={items}
                                        minRows={isMobile ? 1 : 2}
                                        maxRows={isMobile ? 5 : 8}
                                        aiRole={{
                                            avatar: {
                                                src: <img src={initData?.data?.icon} />,
                                            },
                                            loadingRender() {

                                                return (
                                                    <span>
                                                        <ChatLoadingDots />
                                                    </span>
                                                );

                                            },
                                        }}
                                        sendboxTopRender={
                                            initData?.data?.znttype === 2 ? <ChatScrollWrapper>
                                                {
                                                    [{
                                                        name: "123",
                                                        type: "select",
                                                        required: "true",
                                                        id: 1
                                                    }].map((item) => {
                                                        return <ChatActionButton
                                                            key={item.id}
                                                        >
                                                            {item.name}
                                                        </ChatActionButton>
                                                    })
                                                }
                                            </ChatScrollWrapper> : <>

                                                {
                                                    initData?.data.subjects?.length &&
                                                        mode == "conversation" ? (
                                                        <ChatScrollWrapper>
                                                            {initData?.data.subjects?.map((item) => {
                                                                return (
                                                                    <ChatActionButton
                                                                        key={item.id}
                                                                        onClick={(e) => StartChat(item.name)}
                                                                    >
                                                                        {item.name}
                                                                    </ChatActionButton>
                                                                );
                                                            })}
                                                        </ChatScrollWrapper>
                                                    ) : null
                                                }

                                            </>

                                        }
                                        ref={chatBoxRef}
                                        {...chatBoxProps}
                                    />
                                </>
                            )
                        ) : activeMenu === "search" ? (
                            <iframe
                                security=""
                                src="http://bkd.sudytech.cn/sopplus/_web/customized/AIPortalPlus/aisearch/index.html"
                                style={{
                                    border: "none",
                                    outline: "none",
                                    height: "100%",
                                    width: "100%",
                                }}
                            ></iframe>
                        ) : activeMenu === "brain" ? (
                            <Search
                                onClick={(key) => {
                                    console.log(key, "多智能体点击");
                                    if (key?.outerznt) {
                                        window.open(key?.outerurl);
                                    } else {
                                        swtichZnt(key?.key ?? "");
                                    }

                                    //navigate(`chat?znwdId=${key?.key ?? ""}`)
                                }}
                            ></Search>
                        ) : null}
                    </ChatLayout>

                    <ChatFeedBack
                        open={feedback ? true : false}
                        onCancel={() => setFeedback(null)}
                        onSubmit={(text) => {
                            setFeedback(null);
                            return handleEvaluate("bad", text, feedback);
                        }}
                    />
                    {
                        renameOpen ? <Modal
                            destroyOnClose={true}
                            key={renameData?.key}
                            title={
                                <Typography.Title style={{ fontSize: 16 }}>
                                    {"重命名对话"}
                                </Typography.Title>
                            }
                            open={renameOpen}
                            onCancel={() => {
                                setRenameData({})
                                setReNameOpen(false)
                            }}
                            onOk={() => {
                                renameForm.validateFields().then((values) => {
                                    if (values.name) {
                                        runGetUpdateChat({
                                            title: values.name,
                                            chatId: renameData?.key,
                                        });
                                    }
                                }).catch(() => {

                                });
                            }}
                        >
                            <Form key={renameData?.key} form={renameForm} initialValues={{ name: renameData?.name }}>
                                <Form.Item
                                    rules={[{ required: true, message: "对话名称不能为空" }]}
                                    required
                                    name={"name"}
                                >
                                    <Input key={renameData}></Input>
                                </Form.Item>
                            </Form>
                        </Modal> : null
                    }

                </Spin>
            </ChatPortalLayout>
        </ChatContext.Provider>
    );
}
